"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPlugType = exports.ETradeInState = exports.EVehicleEnums = exports.EInventoryState = exports.EMileageSource = exports.EInteriorType = exports.EInteriorColorName = exports.EExteriorColorName = exports.EAvailabilityCode = exports.EBendingLights = exports.EHeadlightType = exports.EDaytimeRunningLights = exports.EAirbags = exports.ERadio = exports.DoorCount = exports.EEmissionSticker = exports.EEmissionClass = exports.EEfficiencyClass = exports.ETransmissionType = exports.EDrivetrain = exports.EFuelType = exports.EVehicleCategory = exports.EVehicleClass = exports.ESpeedControl = exports.EClimatisation = exports.EVehicleUsage = exports.EBreakdownKit = exports.EBidirectionalChargingType = exports.ESlidingDoors = exports.ETrailerCoupling = exports.EVehicleManufacturer = exports.EEmissionSource = void 0;
var EEmissionSource;
(function (EEmissionSource) {
    EEmissionSource["LINK_ENTRY"] = "LINK_ENTRY";
    EEmissionSource["STLA_RETAILER"] = "STLA_RETAILER";
})(EEmissionSource = exports.EEmissionSource || (exports.EEmissionSource = {}));
var EVehicleManufacturer;
(function (EVehicleManufacturer) {
    EVehicleManufacturer["OTHER"] = "OTHER";
    EVehicleManufacturer["FCA"] = "FCA";
})(EVehicleManufacturer = exports.EVehicleManufacturer || (exports.EVehicleManufacturer = {}));
var ETrailerCoupling;
(function (ETrailerCoupling) {
    ETrailerCoupling["ELECTRIC_SWIVELING"] = "ES";
    ETrailerCoupling["MANUAL_SWIVELING"] = "MS";
    ETrailerCoupling["FIX"] = "F";
    ETrailerCoupling["DETACHABLE"] = "D";
    ETrailerCoupling["PREPARATION"] = "P";
})(ETrailerCoupling = exports.ETrailerCoupling || (exports.ETrailerCoupling = {}));
var ESlidingDoors;
(function (ESlidingDoors) {
    ESlidingDoors["LEFT_MANUAL"] = "LM";
    ESlidingDoors["LEFT_AUTOMATIC"] = "LA";
    ESlidingDoors["RIGHT_MANUAL"] = "RM";
    ESlidingDoors["RIGHT_AUTOMATIC"] = "RA";
    ESlidingDoors["BOTH_MANUAL"] = "BM";
    ESlidingDoors["BOTH_AUTOMATIC"] = "BA";
})(ESlidingDoors = exports.ESlidingDoors || (exports.ESlidingDoors = {}));
var EBidirectionalChargingType;
(function (EBidirectionalChargingType) {
    EBidirectionalChargingType["VEHICLE_TO_VEHICLE"] = "V2V";
    EBidirectionalChargingType["VEHICLE_TO_GRID"] = "V2G";
    EBidirectionalChargingType["VEHICLE_TO_HOME"] = "V2H";
    EBidirectionalChargingType["VEHICLE_TO_LOAD"] = "V2L";
    EBidirectionalChargingType["VEHICLE_TO_X"] = "V2X";
    EBidirectionalChargingType["OTHER"] = "OTHER";
})(EBidirectionalChargingType = exports.EBidirectionalChargingType || (exports.EBidirectionalChargingType = {}));
var EBreakdownKit;
(function (EBreakdownKit) {
    EBreakdownKit["SPARE_WHEEL"] = "S";
    EBreakdownKit["EMERGENCY_WHEEL"] = "E";
    EBreakdownKit["REPAIR_KIT"] = "R";
})(EBreakdownKit = exports.EBreakdownKit || (exports.EBreakdownKit = {}));
var EVehicleUsage;
(function (EVehicleUsage) {
    EVehicleUsage["NEW"] = "N";
    EVehicleUsage["DEMONSTRATION"] = "D";
    EVehicleUsage["SINGLE_DAY"] = "S";
    EVehicleUsage["USED"] = "U";
    EVehicleUsage["EMPLOYEE"] = "E";
    EVehicleUsage["RENT"] = "R";
})(EVehicleUsage = exports.EVehicleUsage || (exports.EVehicleUsage = {}));
var EClimatisation;
(function (EClimatisation) {
    EClimatisation["None"] = "NONE";
    EClimatisation["Manual"] = "MANUAL";
    EClimatisation["Auto"] = "AUTO";
    EClimatisation["Auto2Zone"] = "AUTO_2";
    EClimatisation["Auto3Zone"] = "AUTO_3";
    EClimatisation["Auto4Zone"] = "AUTO_4";
})(EClimatisation = exports.EClimatisation || (exports.EClimatisation = {}));
var ESpeedControl;
(function (ESpeedControl) {
    ESpeedControl["CruiseControl"] = "C";
    ESpeedControl["AdaptiveCruiseControl"] = "AC";
})(ESpeedControl = exports.ESpeedControl || (exports.ESpeedControl = {}));
var EVehicleClass;
(function (EVehicleClass) {
    EVehicleClass["Car"] = "CAR";
    EVehicleClass["Motobike"] = "MOTOBIKE";
    EVehicleClass["Bus"] = "BUS";
    EVehicleClass["Motorhome"] = "MOTORHOME";
    EVehicleClass["TruckOver7500"] = "TRUCK_OVER_7500";
    EVehicleClass["TruckUpto7500"] = "TRUCK_UPTO_7500";
    EVehicleClass["Other"] = "OTHER";
})(EVehicleClass = exports.EVehicleClass || (exports.EVehicleClass = {}));
var EVehicleCategory;
(function (EVehicleCategory) {
    EVehicleCategory["Comvertible"] = "CONVERTIBLE";
    EVehicleCategory["Estate"] = "ESTATE";
    EVehicleCategory["Limousine"] = "LIMOUSINE";
    EVehicleCategory["Offroad"] = "OFFROAD";
    EVehicleCategory["Small"] = "SMALL";
    EVehicleCategory["Sports"] = "SPORTS";
    EVehicleCategory["Van"] = "VAN";
    EVehicleCategory["Other"] = "OTHER";
})(EVehicleCategory = exports.EVehicleCategory || (exports.EVehicleCategory = {}));
var EFuelType;
(function (EFuelType) {
    EFuelType["CNG"] = "CNG";
    EFuelType["Diesel"] = "DIESEL";
    EFuelType["Electricity"] = "ELECTRICITY";
    EFuelType["Ethanol"] = "ETHANOL";
    EFuelType["HybridDieselMild"] = "HYBRID_DIESEL_MILD";
    EFuelType["HybridDieselPlugin"] = "HYBRID_DIESEL_PLUGIN";
    EFuelType["HybridPetrolMild"] = "HYBRID_PETROL_MILD";
    EFuelType["HybridPetrolPlugin"] = "HYBRID_PETROL_PLUGIN";
    EFuelType["HybridFull"] = "HYBRID_FULL";
    EFuelType["Hydrogen"] = "HYDROGEN";
    EFuelType["LPG"] = "LPG";
    EFuelType["Petrol"] = "PETROL";
    EFuelType["Other"] = "OTHER";
})(EFuelType = exports.EFuelType || (exports.EFuelType = {}));
var EDrivetrain;
(function (EDrivetrain) {
    EDrivetrain["AllWheel"] = "A";
    EDrivetrain["Front"] = "F";
    EDrivetrain["Back"] = "B";
})(EDrivetrain = exports.EDrivetrain || (exports.EDrivetrain = {}));
var ETransmissionType;
(function (ETransmissionType) {
    ETransmissionType["Auto"] = "AUTOMATIC";
    ETransmissionType["SemiAuto"] = "SEMI_AUTO";
    ETransmissionType["Manual"] = "MANUAL";
})(ETransmissionType = exports.ETransmissionType || (exports.ETransmissionType = {}));
var EEfficiencyClass;
(function (EEfficiencyClass) {
    EEfficiencyClass["APlus"] = "A+";
    EEfficiencyClass["A"] = "A";
    EEfficiencyClass["B"] = "B";
    EEfficiencyClass["C"] = "C";
    EEfficiencyClass["D"] = "D";
    EEfficiencyClass["E"] = "E";
    EEfficiencyClass["F"] = "F";
    EEfficiencyClass["G"] = "G";
})(EEfficiencyClass = exports.EEfficiencyClass || (exports.EEfficiencyClass = {}));
var EEmissionClass;
(function (EEmissionClass) {
    EEmissionClass["EU1"] = "EU1";
    EEmissionClass["EU2"] = "EU2";
    EEmissionClass["EU3"] = "EU3";
    EEmissionClass["EU4"] = "EU4";
    EEmissionClass["EU5"] = "EU5";
    EEmissionClass["EU6"] = "EU6";
    EEmissionClass["EU6A"] = "EU6A";
    EEmissionClass["EU6B"] = "EU6B";
    EEmissionClass["EU6C"] = "EU6C";
    EEmissionClass["EU6D"] = "EU6D";
    EEmissionClass["EU6DTEMP"] = "EU6DTEMP";
    EEmissionClass["EU6E"] = "EU6E";
    EEmissionClass["EU7"] = "EU7";
})(EEmissionClass = exports.EEmissionClass || (exports.EEmissionClass = {}));
var EEmissionSticker;
(function (EEmissionSticker) {
    EEmissionSticker["EU4"] = "EU4";
    EEmissionSticker["EU3"] = "EU3";
    EEmissionSticker["EU2"] = "EU2";
    EEmissionSticker["None"] = "NONE";
})(EEmissionSticker = exports.EEmissionSticker || (exports.EEmissionSticker = {}));
var DoorCount;
(function (DoorCount) {
    DoorCount["TWO_OR_THREE"] = "2/3";
    DoorCount["FOUR_OR_FIVE"] = "4/5";
    DoorCount["SIX_OR_SEVEN"] = "6/7";
})(DoorCount = exports.DoorCount || (exports.DoorCount = {}));
var ERadio;
(function (ERadio) {
    ERadio["TUNER"] = "TUNER";
    ERadio["DAB"] = "DAB";
    ERadio["DAB_AND_TUNER"] = "DAB_AND_TUNER";
})(ERadio = exports.ERadio || (exports.ERadio = {}));
var EAirbags;
(function (EAirbags) {
    EAirbags["DRIVER"] = "DRIVER";
    EAirbags["FRONT"] = "FRONT";
    EAirbags["FRONT_SIDE"] = "FRONT_SIDE";
    EAirbags["FRONT_SIDE_MORE"] = "FRONT_SIDE_MORE";
})(EAirbags = exports.EAirbags || (exports.EAirbags = {}));
var EDaytimeRunningLights;
(function (EDaytimeRunningLights) {
    EDaytimeRunningLights["NORMAL"] = "NORMAL";
    EDaytimeRunningLights["LED"] = "LED";
})(EDaytimeRunningLights = exports.EDaytimeRunningLights || (exports.EDaytimeRunningLights = {}));
var EHeadlightType;
(function (EHeadlightType) {
    EHeadlightType["XENON"] = "XENON";
    EHeadlightType["BI_XENON"] = "BI_XENON";
    EHeadlightType["LED"] = "LED";
    EHeadlightType["LASER"] = "LASER";
})(EHeadlightType = exports.EHeadlightType || (exports.EHeadlightType = {}));
var EBendingLights;
(function (EBendingLights) {
    EBendingLights["BENDING"] = "BENDING";
    EBendingLights["ADAPTIVE"] = "ADAPTIVE";
})(EBendingLights = exports.EBendingLights || (exports.EBendingLights = {}));
var EAvailabilityCode;
(function (EAvailabilityCode) {
    EAvailabilityCode["Available"] = "A";
    // Event = 'E',
    EAvailabilityCode["Reserved"] = "R";
    EAvailabilityCode["Sold"] = "S";
})(EAvailabilityCode = exports.EAvailabilityCode || (exports.EAvailabilityCode = {}));
var EExteriorColorName;
(function (EExteriorColorName) {
    EExteriorColorName["Beige"] = "BEIGE";
    EExteriorColorName["Black"] = "BLACK";
    EExteriorColorName["Blue"] = "BLUE";
    EExteriorColorName["Brown"] = "BROWN";
    EExteriorColorName["Gold"] = "GOLD";
    EExteriorColorName["Green"] = "GREEN";
    EExteriorColorName["Grey"] = "GREY";
    EExteriorColorName["Orange"] = "ORANGE";
    EExteriorColorName["Purple"] = "PURPLE";
    EExteriorColorName["Red"] = "RED";
    EExteriorColorName["Silver"] = "SILVER";
    EExteriorColorName["White"] = "WHITE";
    EExteriorColorName["Yellow"] = "YELLOW";
    EExteriorColorName["Other"] = "OTHER";
})(EExteriorColorName = exports.EExteriorColorName || (exports.EExteriorColorName = {}));
var EInteriorColorName;
(function (EInteriorColorName) {
    EInteriorColorName["Beige"] = "BEIGE";
    EInteriorColorName["Black"] = "BLACK";
    EInteriorColorName["Brown"] = "BROWN";
    EInteriorColorName["Grey"] = "GREY";
    EInteriorColorName["RED"] = "RED";
    EInteriorColorName["BLUE"] = "BLUE";
    EInteriorColorName["Other"] = "OTHER";
})(EInteriorColorName = exports.EInteriorColorName || (exports.EInteriorColorName = {}));
var EInteriorType;
(function (EInteriorType) {
    EInteriorType["Alcantara"] = "ALCANTARA";
    EInteriorType["Fabric"] = "FABRIC";
    EInteriorType["Leather"] = "LEATHER";
    EInteriorType["PartLeather"] = "PART_LEATHER";
    EInteriorType["FauxLeather"] = "FAUX_LEATHER";
    EInteriorType["Velour"] = "VELOUR";
    EInteriorType["Other"] = "OTHER";
})(EInteriorType = exports.EInteriorType || (exports.EInteriorType = {}));
var EMileageSource;
(function (EMileageSource) {
    EMileageSource["FuelReceipt"] = "FUEL";
    EMileageSource["Manual"] = "MANUAL";
})(EMileageSource = exports.EMileageSource || (exports.EMileageSource = {}));
var EInventoryState;
(function (EInventoryState) {
    EInventoryState["Ordered"] = "ORDERED";
    EInventoryState["Stock"] = "STOCK";
    EInventoryState["Sold"] = "SOLD";
})(EInventoryState = exports.EInventoryState || (exports.EInventoryState = {}));
var EVehicleEnums;
(function (EVehicleEnums) {
    EVehicleEnums[EVehicleEnums["EMileageSource"] = 0] = "EMileageSource";
    EVehicleEnums[EVehicleEnums["EVehicleManufacturer"] = 1] = "EVehicleManufacturer";
    EVehicleEnums[EVehicleEnums["EClimatisation"] = 2] = "EClimatisation";
    EVehicleEnums[EVehicleEnums["EVehicleClass"] = 3] = "EVehicleClass";
    EVehicleEnums[EVehicleEnums["EVehicleCategory"] = 4] = "EVehicleCategory";
    EVehicleEnums[EVehicleEnums["EFuelType"] = 5] = "EFuelType";
    EVehicleEnums[EVehicleEnums["EDrivetrain"] = 6] = "EDrivetrain";
    EVehicleEnums[EVehicleEnums["ETransmissionType"] = 7] = "ETransmissionType";
    EVehicleEnums[EVehicleEnums["EEfficiencyClass"] = 8] = "EEfficiencyClass";
    EVehicleEnums[EVehicleEnums["EEmissionClass"] = 9] = "EEmissionClass";
    EVehicleEnums[EVehicleEnums["EEmissionSticker"] = 10] = "EEmissionSticker";
    EVehicleEnums[EVehicleEnums["DoorCount"] = 11] = "DoorCount";
    EVehicleEnums[EVehicleEnums["ERadio"] = 12] = "ERadio";
    EVehicleEnums[EVehicleEnums["EAirbags"] = 13] = "EAirbags";
    EVehicleEnums[EVehicleEnums["EDaytimeRunningLights"] = 14] = "EDaytimeRunningLights";
    EVehicleEnums[EVehicleEnums["EHeadlightType"] = 15] = "EHeadlightType";
    EVehicleEnums[EVehicleEnums["EBendingLights"] = 16] = "EBendingLights";
    EVehicleEnums[EVehicleEnums["EAvailabilityCode"] = 17] = "EAvailabilityCode";
    EVehicleEnums[EVehicleEnums["EExteriorColorName"] = 18] = "EExteriorColorName";
    EVehicleEnums[EVehicleEnums["EInteriorColorName"] = 19] = "EInteriorColorName";
    EVehicleEnums[EVehicleEnums["EInteriorType"] = 20] = "EInteriorType";
    EVehicleEnums[EVehicleEnums["EInventoryState"] = 21] = "EInventoryState";
    EVehicleEnums[EVehicleEnums["ESpeedControl"] = 22] = "ESpeedControl";
    EVehicleEnums[EVehicleEnums["EVehicleUsage"] = 23] = "EVehicleUsage";
})(EVehicleEnums = exports.EVehicleEnums || (exports.EVehicleEnums = {}));
var ETradeInState;
(function (ETradeInState) {
    ETradeInState["IMPORTED"] = "imported";
    ETradeInState["OPEN"] = "open";
})(ETradeInState = exports.ETradeInState || (exports.ETradeInState = {}));
/** For electric and hybrid/electric vehicles */
var EPlugType;
(function (EPlugType) {
    EPlugType["TYPE_1"] = "TYPE_1";
    EPlugType["TYPE_2"] = "TYPE_2";
    EPlugType["CCS_COMBO"] = "CCS_COMBO";
    EPlugType["CHADEMO"] = "CHADEMO";
    EPlugType["SCHUKO"] = "SCHUKO";
    EPlugType["TESLA_SC"] = "TESLA_SC";
})(EPlugType = exports.EPlugType || (exports.EPlugType = {}));
